// extracted by mini-css-extract-plugin
export default {"homepage":"homepage_homepage__-Jag6"};